module.exports = __webpack_public_path__ + "static/media/Cum să predai cu încredere în timpuri dificile.817ebe38.png";